import styled from 'styled-components';

const NewAdvertiserInputStyled = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  margin: 16px 0;
  gap: 16px;
  
  .newAdvertiserInput {
    &__advertiserNameInputContainer, &__advertiserUrlInputContainer {
      flex: 1;
      display: flex;
    }

    &__buttonsContainer {
      display: flex;
      flex-wrap: nowrap;
      align-items: end;
      margin-left: 15px;
      margin-bottom: 7px;
    }

     &__buttonSave, &__buttonCancel {
       margin: 0 2px;
     }
  }
`;

export { NewAdvertiserInputStyled };
